module.exports = __webpack_public_path__ + "static/banner_e.aab4e745.png";